<app-header [forceLightBackground]="true"></app-header>
<div class="data-provider-entity-page">
  <div class="data-provider-entity-page--layout">
    <app-provider-sidebar class="data-provider-entity-page--sidebar"></app-provider-sidebar>
    <div class="data-provider-entity-page--content">
      <app-page-header></app-page-header>
      
      <div class="data-provider-entity-container">
        <div class="form-card">
          <!-- Leaf Pattern Decoration -->
          <div class="form-card--leaf-pattern">
            <img src="/assets-leaf.png" alt="" class="form-card--leaf-image" />
          </div>
          
          <form [formGroup]="dataProviderEntityForm" class="data-provider-entity-form">
            <!-- User Name (disabled) -->
            <div class="form-field">
              <label for="userName" class="form-label">
                User Name
              </label>
              <input
                type="text"
                id="userName"
                formControlName="userName"
                class="form-input input-disabled"
                placeholder="User name"
              />
            </div>

            <!-- Registered Email (disabled) -->
            <div class="form-field">
              <label for="registeredEmail" class="form-label">
                Registered Email
              </label>
              <input
                type="email"
                id="registeredEmail"
                formControlName="registeredEmail"
                class="form-input input-disabled"
                placeholder="Email address"
              />
            </div>

            <!-- Name of the entity (disabled) -->
            <div class="form-field">
              <label for="entityName" class="form-label">
                Name of the Entity
              </label>
              <input
                type="text"
                id="entityName"
                formControlName="entityName"
                class="form-input input-disabled"
                placeholder="Enter Organisation"
              />
            </div>

            <!-- Job Title (disabled) -->
            <div class="form-field">
              <label for="jobTitle" class="form-label">
                Job Title
              </label>
              <input
                type="text"
                id="jobTitle"
                formControlName="jobTitle"
                class="form-input input-disabled"
                placeholder="Enter job title"
              />
            </div>

            <!-- Employee ID (disabled) -->
            <div class="form-field">
              <label for="employeeId" class="form-label">
                Employee ID
              </label>
              <input
                type="text"
                id="employeeId"
                formControlName="employeeId"
                class="form-input input-disabled"
                placeholder="Enter employee ID"
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>



